<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";
import { Account } from "@/services/account";

export default {
  name: "Home",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    // get account info for not exist status in vuex init object
    if (!this.account.status) {
      this.getAccountInfo();
    } else {
      this.redirectUserToPage();
    }
  },
  watch: {
    account: {
      deep: true,
      handler() {
        // check get account data
        if (this.account.status) {
          this.redirectUserToPage();
        }
      },
    },
  },
  methods: {
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
        // deve resolver a trava no home. Ocorre as vezes
        setTimeout(() => {
          this.redirectUserToPage();
        }, 500);
      });
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    redirectUserToPage() {
      // check resource live is enable or redirect

      if (!this.account.resources.includes("populate")) {
        if (this.account.resources && this.account.resources.length === 0) {
          this.$toast.error({
            title: "Erro",
            message: "A conta não tem recursos liberados",
          });
        }

        const resourceRoutes = {};
        // mapper all routes to permissionName
        this.$router.options.routes.forEach((r) => {
          // not get route have props
          if (
            !r.props &&
            r.meta &&
            r.meta.requiresLogin &&
            r.meta.permissionName
          ) {
            // get first route
            if (!resourceRoutes[r.meta.permissionName]) {
              resourceRoutes[r.meta.permissionName] = r.name;
            }
          }
        });

        const resourcesNameInMapper = Object.keys(resourceRoutes);
        const resourcesFromRoute = this.account.resources.filter((r) =>
          resourcesNameInMapper.includes(r)
        );

        if (resourcesFromRoute.length === 0) {
          this.$toast.error({
            title: "Erro",
            message: "A conta não tem recursos liberados",
          });

          return this.logout();
        }

        const firstResource = resourcesFromRoute[0];
        const routeName = resourceRoutes[firstResource];

        this.$router.push({ name: routeName });
      } else {
        // Default home page :)
        // this.$router.push({ name: "Dash", params: { slug: 'profit'} });
        this.$router.push({ name: "Homev2" });
      }
    },
  },
};
</script>
